import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Login } from './login';
import { LoginService } from './login.service';
import { Store } from '@ngrx/store';
import { selectUserCollection } from 'src/app/store/selectors/user.selectors';
import { userDetails } from 'src/app/store/actions/user.actions';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { HttpService } from 'src/app/core/services/http/http.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @ViewChild('loginform') loginFormElement: ElementRef;
  user$ = this.store.select(selectUserCollection);
  userData:any;
  login: Login;
  submitted: Boolean;
  isvalue:string;
  hasError: Boolean;
  Multipleclick:boolean=false;
  loggedInUserId:number;
  errorMessage: string;
  showLoader:boolean = true;
  isLoading :boolean;
  loading:boolean;
  rememberMe: boolean = false;
  state: any;
  apikey: string = '';
  externalUsername: string = '';
  isSignUp:boolean = false;
  isVerificationPage:boolean = false;
  isOTPVerified:boolean = false;
  signUpFormSubmitted: Boolean;
  otpFormSubmitted: Boolean;
  signUpErrorMessage: string;
  otpErrorMessage: string;

  save(): void {
    this.loading = true;
  }

  sendOTP(): void {
    if(this.signUpForm.valid) {
      this.userData= this.signUpForm.value
      const {Email,ClientID}= this.userData
      this.generateOtp('/api/users/generarteOTP',{Email,ClientID})
      this.loading = false;
      this.isLoading = true;
    }
  }

  onVerifyOTP(): void{
    if(this.verifyOtpForm.valid){
      const {digit1,digit2,digit3,digit4} = this.verifyOtpForm.value
      const otp=Number(digit1+digit2+digit3+digit4)
      const signUpDetails = {
        OTPCode:otp,
        ...this.userData
      }
      this.verifyOTP('/api/users/verifyOTP',signUpDetails)
      this.loading = false;
      this.isLoading = true;
    }
  }

  generateOtp(path:string,data:{Email:string,ClientID:number}) {
    this.httpService.post(path,data)
    .subscribe((data)=>{
      this.signUpFormSubmitted = true
      this.isLoading = false;
      if(data.Status == 'Success') {
        this.isVerificationPage = true;
      }else if(data.Status == 'Error'){
        this.signUpErrorMessage = data.Message || 'Unknown Error'
        throw this.signUpErrorMessage
      }
    })
  }

  verifyOTP(path:string,data:any) {
    this.httpService.post(path,data)
    .subscribe((data)=>{
      this.otpFormSubmitted = true
      this.isLoading = false;
      if(data.Status == 'Success') {
        this.isOTPVerified = true
      }else if(data.Status == 'Error'){
        this.otpErrorMessage = data.Message || 'Unknown Error'
        throw this.otpErrorMessage
      }
    })
  }

 toggleSignUpPage():void{
  this.isSignUp = !this.isSignUp
  if(this.isSignUp){
    this.signUpForm.reset()
    this.verifyOtpForm.reset()
  }
  this.errorMessage = ''
  }

  redirectToLogin():void {
    this.isSignUp = false
    this.isVerificationPage = false
    this.isOTPVerified = false
  }

  loggedInUser: {[name: string]: any};
  loginForm = this.fb.group({
    userName: ['', Validators.compose([Validators.required])],
    password: ['', Validators.compose([Validators.required])]
  })

  move(e:KeyboardEvent,prev:HTMLInputElement | null,curr:HTMLInputElement,nxt:HTMLInputElement | null):void {
    var length = curr.value.length
    var maxLength = Number(curr.getAttribute('maxlength'))
    if(length == maxLength){
      if(nxt){
        nxt.focus()
      }
    }
    if(e.key === 'Backspace'){
      if(prev){
        prev.focus()
      }
    }
  }

  signUpForm = this.fb.group({
    FirstName: ['', Validators.compose([Validators.required])],
    LastName: ['', []],
    Email: ['', Validators.compose([Validators.required])],
    Password: ['', Validators.compose([Validators.required])],
    ClientID: ['', Validators.compose([Validators.required])]
  })

  verifyOtpForm = this.fb.group({ 
    digit1: ['', Validators.compose([Validators.required])], 
    digit2: ['', Validators.compose([Validators.required])], 
    digit3: ['', Validators.compose([Validators.required])], 
    digit4: ['', Validators.compose([Validators.required])] 
  });

  async onSubmitLogIn() {
    console.log(this.loginForm, '***LOGIN FORM***')
    this.submitted = true
    this.hasError = false
    if (this.loginForm.valid) {
      if(this.rememberMe){
        this.cookieService.set('userName', this.loginForm.value.userName)
      }
      else{
        if(this.cookieService.get('userName')){
          this.cookieService.delete('userName')
        }
      }

      let returnUrl: string =  '';
      this.activatedRoute.queryParams.subscribe(params => {
        returnUrl = params['returnUrl'];
        console.log(returnUrl);
      })

      if(returnUrl) {
        let data = { Username: this.loginForm.value.userName, Password: this.loginForm.value.password, ReturnUrl: returnUrl }
        let baseUrl: string = environment.BASE_URL
        // const res = await fetch(`${baseUrl}/api/authenticate`, {
        //   method: "POST",
        //   credentials: "include",
        //   headers: {
        //     "Content-Type": "application/json",
        //     "Access-Control-Allow-Credentials": 'true',
        //   },
        //   body: JSON.stringify(data),
        // })
        // this.loading = false;
        // const resdata = await res.json();
        // console.log(resdata, '**response')
        // if(resdata.Status == 'Success') {
        //   window.location = resdata.ReturnUrl
        // }
        // else if(resdata.Status == 'Error') {
        //   this.hasError = true;
        //   this.isLoading = false;
        //   this.errorMessage = resdata.Message || 'Unknown Error'
        //   throw this.errorMessage
        // }
        // let form = document.createElement('form')
        var clientId = this.cookieService.get('externalPinsheetClientId')
        let returnUrlElement = document.createElement('input')
        returnUrlElement.setAttribute('type', 'hidden')
        returnUrlElement.setAttribute('name', 'ReturnUrl')
        returnUrlElement.setAttribute('value', returnUrl)
        if (clientId) {
          let clientIdElement = document.createElement('input');
          clientIdElement.setAttribute('type', 'hidden');
          clientIdElement.setAttribute('name', 'ClientId');
          clientIdElement.setAttribute('value', clientId);
          this.loginFormElement.nativeElement.appendChild(clientIdElement)
        }
        // form.appendChild(returnUrlElement)
        this.loginFormElement.nativeElement.appendChild(returnUrlElement)
        this.loginFormElement.nativeElement.action = `${environment.BASE_URL}/api/authenticate`
        this.loginFormElement.nativeElement.method = 'POST'
        this.loginFormElement.nativeElement.submit()

        const bc = new BroadcastChannel("ezlo-web");
        bc.postMessage("login")
        bc.close()
      }
      else {
        var data: any = {
          Email: this.loginForm.value.userName,
          Password: this.loginForm.value.password,
        }
        if(this.apikey && this.externalUsername) {
          data.Apikey = this.apikey,
          data.ExternalUsername = this.externalUsername 
        }
        var clientId = this.cookieService.get('clientId')
        if(clientId){
          data.ClientId = clientId
        }

        this.loginService.login(data)
          .subscribe((response) => {
            this.loading = false;
            if (response.Status === 'Error') {
              this.hasError = true;
              this.isLoading = false;
              this.errorMessage = response.Message || 'Unknown Error'
              throw this.errorMessage
            }
            this.cookieService.delete('externalPinsheetClientId')
            this.cookieService.delete('externalPinsheetCourseId')
  
            let loginData = response.Data
  
            this.cookieService.set('accessToken', loginData.AccessToken)
            this.cookieService.set('refreshToken', loginData.RefreshToken)
            this.httpService.refreshExpirationCounter(this.httpService.getTokenExpiry(loginData.RefreshToken)*1000)
            if(this.apikey && this.externalUsername) {
              this.cookieService.set('externalSession', 'true')
            }

            this.loginService.getUserInfo()
              .subscribe((user) => {
                if(user.Status == 'Success'){
                  this.loading = false;
                  this.isLoading = false;
                    user = user.Data
                    this.store.dispatch(userDetails({user}))
                    this.loggedInUser = this.user$
                    console.log(user.UserId)
                    this.cookieService.set('loggedInUserId', user.UserId)
                    if(user.RightsId != 1){
                      this.cookieService.set('clientId', user.ClientId)
                    }
                    this.router.navigate(['pinsheet'])
                  }
                },
                (error: Error | HttpErrorResponse) => {
                  console.log(error)
                  this.hasError = true;
                  this.errorMessage = 'error while login'
                  throw error
                })
          },
            (error: Error | HttpErrorResponse) => {
              console.error('error caught in component')
              this.hasError = true;
              this.errorMessage = 'error while login'
              throw error
            }
          )
      }
    }
    this.isLoading = true;
  }

  changeRememberMe(){
    this.rememberMe = !this.rememberMe
  }

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private loginService: LoginService,
    private cookieService: CookieService,
    private store:Store,
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private httpService: HttpService,
    private dialog: MatDialog,
    private ngxLoader: NgxUiLoaderService
  ) {
    this.titleService.setTitle('EZLocator Login');
    if(this.cookieService.get('userName')){
      this.loginForm.controls['userName'].setValue(this.cookieService.get('userName'));
      this.rememberMe = true 
    }

    let state = this.router.getCurrentNavigation()?.extras.state
    if(state) {
      this.apikey = state.apikey
      this.externalUsername = state.externalUsername
      return
    }

    let returnUrl: string =  '';
    let message: string = '';
    this.activatedRoute.queryParams.subscribe(params => {
      returnUrl = params['returnUrl'];
      message = params['message']
    })
    if(returnUrl){
      if(message){
        this.submitted = true
        this.hasError = true;
        this.isLoading = false;
        this.errorMessage = message || 'Unknown Error'
        // throw this.errorMessage
      }
      return
    }
    let params = new URLSearchParams({
      'client_id': environment.CLIENT_ID,
      'redirect_uri': `${window.location.origin}/authorize`,
      'response_type':'code',
      'scope': 'openid profile offline_access'
    });
    //authorize endpoint call
    let baseUrl: string = environment.BASE_URL
    window.location.href = `${baseUrl}/connect/authorize?${params.toString()}`
  }

  ngOnInit(): void {
    console.log( '***LOGIN PAGE***')
  }

}
